import type { NavigationLinkIconType } from '@hypercodestudio/basler-components';

export function getLinkIconPosition(
  linkIconPosition: 'left' | 'right' | undefined
): NavigationLinkIconType {
  return linkIconPosition === 'right'
    ? 'icon-right'
    : linkIconPosition === 'left'
      ? 'icon-left'
      : 'no-icon';
}
